"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getObjectiveProgressionByCombination = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _getActivityProgressionForObjective = _interopRequireDefault(require("./getActivityProgressionForObjective"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getProgression = function getProgression(_ref) {
  var _objectivesProgressio, _objectivesProgressio2, _objectivesProgressio7, _objectivesProgressio8, _objectivesProgressio9, _objectivesProgressio10;

  var objectivesProgression = _ref.objectivesProgression,
      combinationIndex = _ref.combinationIndex,
      condition = _ref.condition;
  var frequencyRepeat = condition.frequencyRepeat,
      frequency = condition.frequency,
      repeat = condition.repeat;
  var completedActivities = objectivesProgression === null || objectivesProgression === void 0 ? void 0 : (_objectivesProgressio = objectivesProgression[combinationIndex]) === null || _objectivesProgressio === void 0 ? void 0 : (_objectivesProgressio2 = _objectivesProgressio.frequencies) === null || _objectivesProgressio2 === void 0 ? void 0 : _objectivesProgressio2.flatMap(function (frequency) {
    var _frequency$repetition;

    return (_frequency$repetition = frequency.repetitions) === null || _frequency$repetition === void 0 ? void 0 : _frequency$repetition.flatMap(function (repetition) {
      return [].concat((0, _toConsumableArray2["default"])(repetition.activityIds), (0, _toConsumableArray2["default"])(repetition.userActions));
    });
  });

  if (frequencyRepeat && frequency || repeat) {
    var _objectivesProgressio3, _objectivesProgressio4, _objectivesProgressio5, _objectivesProgressio6;

    var getCompletedObjectives = function getCompletedObjectives(items) {
      return (items === null || items === void 0 ? void 0 : items.filter(function (item) {
        return item === null || item === void 0 ? void 0 : item.isFinished;
      }).length) || 0;
    };

    var frequenciesOrRepetitions = frequency ? objectivesProgression === null || objectivesProgression === void 0 ? void 0 : (_objectivesProgressio3 = objectivesProgression[combinationIndex]) === null || _objectivesProgressio3 === void 0 ? void 0 : _objectivesProgressio3.frequencies : objectivesProgression === null || objectivesProgression === void 0 ? void 0 : (_objectivesProgressio4 = objectivesProgression[combinationIndex]) === null || _objectivesProgressio4 === void 0 ? void 0 : (_objectivesProgressio5 = _objectivesProgressio4.frequencies) === null || _objectivesProgressio5 === void 0 ? void 0 : (_objectivesProgressio6 = _objectivesProgressio5[0]) === null || _objectivesProgressio6 === void 0 ? void 0 : _objectivesProgressio6.repetitions;
    var completedObjectives = getCompletedObjectives(frequenciesOrRepetitions);
    return _objectSpread({}, condition, {
      completedActivities: completedActivities,
      progression: {
        goal: frequencyRepeat || repeat || 0,
        value: completedObjectives
      }
    });
  }

  var _getActivityProgressi = (0, _getActivityProgressionForObjective["default"])({
    objective: condition,
    activity: objectivesProgression === null || objectivesProgression === void 0 ? void 0 : (_objectivesProgressio7 = objectivesProgression[combinationIndex]) === null || _objectivesProgressio7 === void 0 ? void 0 : (_objectivesProgressio8 = _objectivesProgressio7.frequencies) === null || _objectivesProgressio8 === void 0 ? void 0 : (_objectivesProgressio9 = _objectivesProgressio8[0]) === null || _objectivesProgressio9 === void 0 ? void 0 : (_objectivesProgressio10 = _objectivesProgressio9.repetitions) === null || _objectivesProgressio10 === void 0 ? void 0 : _objectivesProgressio10[0]
  }),
      goal = _getActivityProgressi.goal,
      percentageCompleted = _getActivityProgressi.percentageCompleted,
      value = _getActivityProgressi.value;

  return _objectSpread({}, condition, {
    completedActivities: completedActivities,
    progression: {
      goal: goal,
      value: value,
      percentageCompleted: percentageCompleted
    }
  });
};

var getObjectiveProgressionByCombination = function getObjectiveProgressionByCombination(_ref2) {
  var challenge = _ref2.challenge;
  var conditions = challenge.conditions,
      userChallenge = challenge.userChallenge;
  var combinations = conditions.combinations;
  var currentChallenge = userChallenge;

  var _ref3 = currentChallenge || {},
      _ref3$calculationStat = _ref3.calculationState;

  _ref3$calculationStat = _ref3$calculationStat === void 0 ? {} : _ref3$calculationStat;
  var _ref3$calculationStat2 = _ref3$calculationStat.progression;
  _ref3$calculationStat2 = _ref3$calculationStat2 === void 0 ? {} : _ref3$calculationStat2;
  var _ref3$calculationStat3 = _ref3$calculationStat2.objectives,
      objectivesProgression = _ref3$calculationStat3 === void 0 ? [] : _ref3$calculationStat3;

  if (!combinations || !combinations.length) {
    return [getProgression({
      condition: conditions,
      combinationIndex: 0,
      objectivesProgression: objectivesProgression
    })];
  } else {
    return combinations.map(function (combination, index) {
      return getProgression({
        condition: combination,
        combinationIndex: index,
        objectivesProgression: objectivesProgression
      });
    });
  }
};

exports.getObjectiveProgressionByCombination = getObjectiveProgressionByCombination;
var _default = getObjectiveProgressionByCombination;
exports["default"] = _default;
//# sourceMappingURL=getObjectiveProgressionByCombination.js.map